import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45uuid_45global from "/vercel/path0/middleware/01.uuid.global.ts";
import _02_45oidc_45global from "/vercel/path0/middleware/02.oidc.global.ts";
import _03_45sentry_45global from "/vercel/path0/middleware/03.sentry.global.ts";
export const globalMiddleware = [
  validate,
  _01_45uuid_45global,
  _02_45oidc_45global,
  _03_45sentry_45global
]
export const namedMiddleware = {}